import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "CEO of a leading Australian brokerage",
    content:
      "It’s fantastic to see so many professionals coming together to support home buyers. Keep up the great work in building this trusted network!",
  },
  {
    id: 2,
    name: "Rakesh Routhu",
    role: "Entrepreneur, Advisor, HBN-Tech",
    content:
      "A game changing and much needed platform for the real estate industry set to benefit both the brokers as well as the buyers.",
  },
  {
    id: 3,
    name: "Ashwin Nooli",
    role: "Building and Pest inspector",
    content:
      "As a building inspector, I found setting up on this platform to be a breeze. It truly is a one-stop solution for anyone starting their new home journey. I’m happy to share that I’ve already connected with clients here and look forward to using the platform going forward.",
  },
  {
    id: 4,
    name: "Kiran Gonuguntla",
    // role: "Home Buyer",
    content:
      "Can't find more stars to give to HBN Tech. Buying a home can feel overwhelming, but with HBN Tech it was honestly like a breeze. What stood out most was how simple they made it to connect with everyone I needed—finance, conveyancer, inspectors—all in one place. That’s how I found Kaleb, who was a perfect fit and made the process so much smoother. I really like HBN’s concept of bringing all the real estate professionals together on a single platform—it took away the stress of searching around and gave me peace of mind that I had the right people on my side. Highly recommend!",
  },
  {
    id: 5,
    name: "Kamlesh Parmar",
    content:
      "I met with Shamus on HBN and found the session very effective in relation to my current holdings and investments. I have received the best possible estimates for purchasing, along with a comprehensive package available for support from experts regarding suitable suburbs to invest in.",
  },
];

export function TestimonialsSection() {
  const scrollRef = useRef(null);

  // Auto-scroll logic
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let scrollInterval;
    let direction = 1;

    const startAutoScroll = () => {
      scrollInterval = setInterval(() => {
        if (!container) return;

        // Smooth horizontal scrolling
        container.scrollLeft += 1 * direction;

        // Reverse direction when reaching ends
        if (
          container.scrollLeft + container.clientWidth >=
          container.scrollWidth
        ) {
          direction = -1;
        } else if (container.scrollLeft <= 0) {
          direction = 1;
        }
      }, 20); // speed (smaller = faster)
    };

    startAutoScroll();
    return () => clearInterval(scrollInterval);
  }, []);

  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            What People Are Saying
          </h2>
          <p className="text-xl text-gray-600">
            Trusted by industry leaders and professionals across Australia
          </p>
        </motion.div>

        {/* Horizontal Scroll Testimonials */}
        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto scroll-smooth no-scrollbar"
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="min-w-[300px] sm:min-w-[350px] md:min-w-[400px]"
            >
              <Card className="h-full bg-white/80 backdrop-blur-sm border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-8">
                  <div className="flex items-center mb-6">
                    <Quote className="text-purple-500 h-8 w-8 mr-3" />
                  </div>
                  <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                    "{testimonial.content}"
                  </p>
                  <div>
                    <h4 className="font-semibold text-gray-800">
                      — {testimonial.name}
                    </h4>
                    {testimonial.role && (
                      <p className="text-gray-600 text-sm">{testimonial.role}</p>
                    )}
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>

        {/* Dot indicator */}
        <div className="flex justify-center mt-8">
          <div className="w-3 h-3 rounded-full bg-purple-500 scale-125" />
        </div>
      </div>
    </section>
  );
}